



































helpers = require('../../helpers.coffee')

view_model =
  props:
    hide_on_confirm:
      default: true

  data: ->
    name: ''
    tagColors: @colors()

  methods:
    close: ->
      @errors.clear()
      jQuery("#create-tag").modal 'hide'

    create: ->
      @$validator.validateAll().then (success) =>
        params =
          name: @name
          color: @color()

        Loader.on()
        new TagsResource().create(@createSuccess, @handleApiErrors, params)
      .catch () =>
        @errors

    createSuccess: (data) ->
      Loader.off()
      @close()
      alertify.success 'Salvo com sucesso'

      @name = ''
      @tagColors.forEach (color) -> color.class = ''

      EventsBus.$emit 'MassActions:Autocomplete:TagCreated', data.tag

    setColor: (color) ->
      @tagColors.forEach (color) -> color.class = ''
      color.class = 'selected'

    colors: ->
      Tag.colors.map (color) -> { hex: color, class: '' }

    color: ->
      @tagColors.find((color) -> color.class == 'selected')?.hex

    show: (data) ->
      @name = data.name
      jQuery("#create-tag").modal 'show' if data.id == "create-tag"

    loadInfo: ->
      @contact_resource.transferInfo @loadInfoSuccess, @unknownError,

  created: ->
    EventsBus.$on 'confirm-modal-show', @show
    @contact_resource = new ContactsResource Session.current_company.id

  beforeDestroy: ->
    EventsBus.$off 'confirm-modal-show', @show

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/create_tag_modal.vue